import React from "react";

const CartContext = React.createContext({
  items: [],
  totalAmount: (item) => {},
  addItem: (item) => {},
  removeItem: (id) => {},
});

export default CartContext;
